var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#folder_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3A3",
    d: "M3.464 4.5h7.786V3.375c0-.621-.504-1.125-1.125-1.125h-3.75l-1.5-1.5h-3.75C.504.75 0 1.254 0 1.875v7.697l2.122-4.245c.255-.508.77-.827 1.342-.827m9.265.75H3.464a.747.747 0 0 0-.67.415L0 11.25h10.479a.75.75 0 0 0 .67-.415l2.25-4.5c.27-.5-.093-1.085-.67-1.085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "folder_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13.5v12H0z"
  })))));
};
export default SvgFolder;